import Vue from 'vue'
import RootPage from '@/views/pages/RootPage.vue'
import router from '@/views/routers'
import store from '@/core/store'
import exceptionHandler from '@/core/exceptions/ExceptionHandler'
import vuetify from '@/plugins/vuetify'

class RootPageCreator {
    createInstance() {
        new Vue({
            router,
            store,
            vuetify,
            render: h => h(RootPage),
            errorCaptured(error) {
                exceptionHandler.execute(error)
                return false
            }
        }).$mount('#app')
    }

    createBootstrapError() {
        new Vue({
            el: '#app',
            render(createElement) {
                return createElement('div', {
                    'class': 'erro-inicializacao'
                }, [
                    createElement('div', {}, [
                        createElement('i', {
                            'class': 'far fa-surprise'
                        }),
                        createElement('p', 'Ocorreu um erro na inicialização desta aplicação.')
                    ])
                ])
            }
        })
    }
}

export default new RootPageCreator()
